class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const dialog = this.portaledDialog;
    const clickedInside =
      this.contains(event.target) || (dialog && dialog.contains(event.target));
    if (!clickedInside || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  lockPageScroll() {
    this.savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.appointmentScrollY = String(this.savedScrollY);
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.classList.add('appointment-modal-open');
    document.documentElement.classList.add('appointment-modal-open');
  }

  unlockPageScroll() {
    const scrollY = Number(document.body.dataset.appointmentScrollY || this.savedScrollY || 0);
    document.body.classList.remove('appointment-modal-open');
    document.documentElement.classList.remove('appointment-modal-open');
    document.body.style.top = '';
    delete document.body.dataset.appointmentScrollY;
    window.scrollTo(0, scrollY);
  }

  moveDialogToBody() {
    if (!this.classList.contains('header__appointment')) return;
    const dialog = this.querySelector('.header__appointment-modal');
    if (!dialog) return;

    if (dialog.parentElement !== document.body) {
      this.dialogHome = dialog.parentElement;
      dialog.classList.add('is-open');
      document.body.appendChild(dialog);
    } else {
      dialog.classList.add('is-open');
    }

    this.portaledDialog = dialog;
  }

  restoreDialog() {
    const dialog = this.portaledDialog;
    if (!dialog) return;
    dialog.classList.remove('is-open');
    if (this.dialogHome && dialog.parentElement !== this.dialogHome) {
      this.dialogHome.appendChild(dialog);
    }
    this.portaledDialog = null;
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details =
      (event && event.target && event.target.closest && event.target.closest('details')) ||
      this.detailsContainer;
    if (!details) return;

    this.lockPageScroll();
    details.setAttribute('open', true);
    this.moveDialogToBody();
    document.body.addEventListener('click', this.onBodyClickEvent);

    const container =
      (this.portaledDialog && this.portaledDialog.querySelector('[tabindex="-1"]')) ||
      this.detailsContainer.querySelector('[tabindex="-1"]') ||
      this.portaledDialog ||
      this.detailsContainer;
    const focusTarget =
      (this.portaledDialog && this.portaledDialog.querySelector('button, [href]')) ||
      this.detailsContainer.querySelector('input:not([type="hidden"])') ||
      this.detailsContainer.querySelector('button, [href], summary');

    trapFocus(container, focusTarget || container);
    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus({ preventScroll: true });
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    this.restoreDialog();
    this.unlockPageScroll();
  }
}

customElements.define('details-modal', DetailsModal);
